import _defineProperty from "/home/jenkins/jenkins_home/workspace/INSi-Consult-dev/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
import { actionChannel, call, delay, put, select, take } from 'redux-saga/effects';
import { initApplicationFailure, initApplicationSuccess, logout, logoutSuccess, setConnectorKo, setConnectorOk, setConnectorVersionKo, setDcParamsRegistered, setDcParamsUnregistered, setLicenseAfterFormOK, setSessionKo, setSessionOk, clearSession, dmpCommandFailureContextualizedType, dmpCommandSuccessContextualizedType, startCpxMonitoring, setLicenseMonitoringLoading, readCpxProcess, setWsInitError, setWsInitLoading } from '../actions';
import { getApiType, getApplicationId, getConfigurationValue, getCpxReader, getCurrentPathname as getCurrentPathnameAccessor, getDcParams, getDmpConnectJSVersion, getEsCertificate, getMSSEsCertificates, getProductionMode, getRemoteControlAppName, getSessionId as getSessionIdAccessor, getSessionTimeout, getTseActive, getTseWhoami, isEsLoginActive, isRemoteControlActive } from '../helpers/accessors';
import { API_TYPES, apiSections, dmpconnectActionConstants, dmpconnectInitActionConstants } from '../constants';
import { checkDMPConnectJSVersion } from '../rules/systemRules';
import { checkConnector, handleDmpParameters, handleGetInteropCodes, handleGetNosCodes } from './utilsSagas';
import getCommandAction from "../actions/config/generateCommands";
import commands from "../actions/config/commands";
import { formatOpenSessionParams } from '../actions/config/commandParamsFormatters';
import { getSavedPinCode } from './errorHandlersSagas';
var getSessionId = function getSessionId(state) {
  return getSessionIdAccessor(state);
};
export var checkIfDcParamsRegistered = /*#__PURE__*/_regeneratorRuntime().mark(function checkIfDcParamsRegistered(dcParams) {
  var result;
  return _regeneratorRuntime().wrap(function checkIfDcParamsRegistered$(_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        _context.next = 2;
        return put(getCommandAction(commands.isDcParamsRegistered, apiSections.IS_REGISTERED_DC_PARAMS, dcParams, {
          silentError: true
        }));
      case 2:
        _context.next = 4;
        return take([dmpCommandSuccessContextualizedType(apiSections.IS_REGISTERED_DC_PARAMS), dmpCommandFailureContextualizedType(apiSections.IS_REGISTERED_DC_PARAMS)]);
      case 4:
        result = _context.sent;
        if (!(result && result.type === dmpCommandSuccessContextualizedType(apiSections.IS_REGISTERED_DC_PARAMS))) {
          _context.next = 9;
          break;
        }
        return _context.abrupt("return", result.data && result.data.i_registered === 1);
      case 9:
        _context.next = 11;
        return put(setWsInitError(result.data));
      case 11:
        return _context.abrupt("return", null);
      case 12:
      case "end":
        return _context.stop();
    }
  }, checkIfDcParamsRegistered);
});
export var registerDcParameters = /*#__PURE__*/_regeneratorRuntime().mark(function registerDcParameters() {
  var apiType, dcParams, isRegistered, result;
  return _regeneratorRuntime().wrap(function registerDcParameters$(_context2) {
    while (1) switch (_context2.prev = _context2.next) {
      case 0:
        _context2.next = 2;
        return select(getApiType);
      case 2:
        apiType = _context2.sent;
        if (!(apiType === API_TYPES.REST)) {
          _context2.next = 8;
          break;
        }
        _context2.next = 6;
        return put(setWsInitError(null));
      case 6:
        _context2.next = 8;
        return put(setWsInitLoading(true));
      case 8:
        _context2.next = 10;
        return select(getDcParams);
      case 10:
        dcParams = _context2.sent;
        _context2.next = 13;
        return call(checkIfDcParamsRegistered, dcParams);
      case 13:
        isRegistered = _context2.sent;
        if (!(isRegistered === false)) {
          _context2.next = 41;
          break;
        }
        _context2.next = 17;
        return put(getCommandAction(commands.registerDcParams, apiSections.REGISTER_DC_PARAMS, dcParams));
      case 17:
        _context2.next = 19;
        return take([dmpCommandSuccessContextualizedType(apiSections.REGISTER_DC_PARAMS), dmpCommandFailureContextualizedType(apiSections.REGISTER_DC_PARAMS)]);
      case 19:
        result = _context2.sent;
        if (!(result && result.type === dmpCommandSuccessContextualizedType(apiSections.REGISTER_DC_PARAMS))) {
          _context2.next = 32;
          break;
        }
        _context2.next = 23;
        return put(setDcParamsRegistered());
      case 23:
        if (!(apiType !== API_TYPES.REST)) {
          _context2.next = 28;
          break;
        }
        _context2.next = 26;
        return put(setConnectorOk());
      case 26:
        _context2.next = 30;
        break;
      case 28:
        _context2.next = 30;
        return put(setWsInitError(null));
      case 30:
        _context2.next = 39;
        break;
      case 32:
        if (!(apiType !== API_TYPES.REST)) {
          _context2.next = 37;
          break;
        }
        _context2.next = 35;
        return put(initApplicationFailure(result.data));
      case 35:
        _context2.next = 39;
        break;
      case 37:
        _context2.next = 39;
        return put(setWsInitError(result.data));
      case 39:
        _context2.next = 62;
        break;
      case 41:
        if (!(isRegistered === true)) {
          _context2.next = 53;
          break;
        }
        _context2.next = 44;
        return put(setDcParamsRegistered());
      case 44:
        if (!(apiType !== API_TYPES.REST)) {
          _context2.next = 49;
          break;
        }
        _context2.next = 47;
        return put(setConnectorOk());
      case 47:
        _context2.next = 51;
        break;
      case 49:
        _context2.next = 51;
        return put(setWsInitError(null));
      case 51:
        _context2.next = 62;
        break;
      case 53:
        if (!(apiType !== API_TYPES.REST)) {
          _context2.next = 62;
          break;
        }
        _context2.next = 56;
        return put(setConnectorKo());
      case 56:
        _context2.next = 58;
        return put(initApplicationFailure());
      case 58:
        _context2.next = 60;
        return delay(5000);
      case 60:
        _context2.next = 62;
        return call(registerDcParameters);
      case 62:
      case "end":
        return _context2.stop();
    }
  }, registerDcParameters);
});
export var unregisterDcParameters = /*#__PURE__*/_regeneratorRuntime().mark(function unregisterDcParameters() {
  var dcParams, isRegistered;
  return _regeneratorRuntime().wrap(function unregisterDcParameters$(_context3) {
    while (1) switch (_context3.prev = _context3.next) {
      case 0:
        _context3.next = 2;
        return select(getDcParams);
      case 2:
        dcParams = _context3.sent;
        _context3.next = 5;
        return call(checkIfDcParamsRegistered, dcParams);
      case 5:
        isRegistered = _context3.sent;
        if (!(isRegistered === true)) {
          _context3.next = 13;
          break;
        }
        _context3.next = 9;
        return put(getCommandAction(commands.unregisterDcParams, apiSections.UNREGISTER_DC_PARAMS, dcParams));
      case 9:
        _context3.next = 11;
        return take(dmpCommandSuccessContextualizedType(apiSections.UNREGISTER_DC_PARAMS));
      case 11:
        _context3.next = 13;
        return put(setDcParamsUnregistered());
      case 13:
      case "end":
        return _context3.stop();
    }
  }, unregisterDcParameters);
});
var getMSSEsCertificate = function getMSSEsCertificate(_ref) {
  var dmpconnectESConfiguration = _ref.dmpconnectESConfiguration;
  return getConfigurationValue('esMssCertificate', dmpconnectESConfiguration);
};
var openSession = /*#__PURE__*/_regeneratorRuntime().mark(function openSession() {
  var dcParams, tseActive, tseWhoami, sessionId, pathname, productionMode, applicationId, remoteControlActive, remoteControlAppName, esCertificate, _yield$select, esMssCertificate, esMssImapCertificate, esMssSmtpCertificate, esMssWsCertificate, sessionTimeout, openSessionParams, sessionActive, createSession, _yield$take, type, _yield$take2, _type, data, s_commandName, s_serviceVersion, minimumVersion;
  return _regeneratorRuntime().wrap(function openSession$(_context4) {
    while (1) switch (_context4.prev = _context4.next) {
      case 0:
        _context4.next = 2;
        return select(getDcParams);
      case 2:
        dcParams = _context4.sent;
        _context4.next = 5;
        return select(getTseActive);
      case 5:
        tseActive = _context4.sent;
        _context4.next = 8;
        return select(getTseWhoami);
      case 8:
        tseWhoami = _context4.sent;
        _context4.next = 11;
        return select(getSessionId);
      case 11:
        sessionId = _context4.sent;
        _context4.next = 14;
        return select(getCurrentPathnameAccessor);
      case 14:
        pathname = _context4.sent;
        _context4.next = 17;
        return select(getProductionMode);
      case 17:
        productionMode = _context4.sent;
        _context4.next = 20;
        return select(getApplicationId);
      case 20:
        applicationId = _context4.sent;
        _context4.next = 23;
        return select(isRemoteControlActive);
      case 23:
        remoteControlActive = _context4.sent;
        _context4.next = 26;
        return select(getRemoteControlAppName);
      case 26:
        remoteControlAppName = _context4.sent;
        _context4.next = 29;
        return select(getEsCertificate);
      case 29:
        esCertificate = _context4.sent;
        _context4.next = 32;
        return select(getMSSEsCertificates);
      case 32:
        _yield$select = _context4.sent;
        esMssCertificate = _yield$select.esMssCertificate;
        esMssImapCertificate = _yield$select.esMssImapCertificate;
        esMssSmtpCertificate = _yield$select.esMssSmtpCertificate;
        esMssWsCertificate = _yield$select.esMssWsCertificate;
        _context4.next = 39;
        return select(getSessionTimeout);
      case 39:
        sessionTimeout = _context4.sent;
        openSessionParams = {
          dcParams: dcParams,
          tseWhoami: tseActive ? tseWhoami : null,
          prodMode: productionMode,
          applicationId: remoteControlActive ? "".concat(applicationId, "-").concat(remoteControlAppName.replace(' ', '-')) : applicationId,
          esMssConfig64: esMssCertificate,
          esMssImapConfig64: esMssImapCertificate,
          esMssSmtpConfig64: esMssSmtpCertificate,
          esMssWsConfig64: esMssWsCertificate,
          esConfig64: esCertificate,
          sessionTimeout: sessionTimeout
        };
        sessionActive = false;
        createSession = true; // If we have a session opened
        if (!sessionId) {
          _context4.next = 59;
          break;
        }
        _context4.next = 46;
        return put(getCommandAction(commands.getSessionState, apiSections.SESSION_STATE_SECTION, null, {
          synchronous: true,
          // if we are on the login page, the error should be silent in order to create the session automatically
          silentError: pathname === '/'
        }));
      case 46:
        _context4.next = 48;
        return take([dmpCommandSuccessContextualizedType(apiSections.SESSION_STATE_SECTION), dmpCommandFailureContextualizedType(apiSections.SESSION_STATE_SECTION)]);
      case 48:
        _yield$take = _context4.sent;
        type = _yield$take.type;
        if (!(type === dmpCommandFailureContextualizedType(apiSections.SESSION_STATE_SECTION))) {
          _context4.next = 57;
          break;
        }
        _context4.next = 53;
        return put(logoutSuccess());
      case 53:
        _context4.next = 55;
        return put(clearSession());
      case 55:
        _context4.next = 59;
        break;
      case 57:
        sessionActive = true;
        createSession = false;
      case 59:
        if (!sessionActive) {
          _context4.next = 70;
          break;
        }
        if (!(pathname === '/')) {
          _context4.next = 70;
          break;
        }
        _context4.next = 63;
        return put(logoutSuccess());
      case 63:
        _context4.next = 65;
        return put(getCommandAction(commands.closeSession, apiSections.SESSION_SECTION, null, {
          synchronous: true
        }));
      case 65:
        _context4.next = 67;
        return take([dmpCommandSuccessContextualizedType(apiSections.SESSION_SECTION), dmpCommandFailureContextualizedType(apiSections.SESSION_SECTION)]);
      case 67:
        _context4.next = 69;
        return put(clearSession());
      case 69:
        createSession = true;
      case 70:
        if (!(createSession === true)) {
          _context4.next = 104;
          break;
        }
        _context4.next = 73;
        return put(getCommandAction(commands.openSession, apiSections.SESSION_SECTION, formatOpenSessionParams(openSessionParams), {
          synchronous: true,
          contextExtra: {
            forceModal: true
          }
        }));
      case 73:
        _context4.next = 75;
        return take([dmpCommandSuccessContextualizedType(apiSections.SESSION_SECTION), dmpCommandFailureContextualizedType(apiSections.SESSION_SECTION)]);
      case 75:
        _yield$take2 = _context4.sent;
        _type = _yield$take2.type;
        data = _yield$take2.data;
        s_commandName = _yield$take2.command.s_commandName;
        if (!(_type === dmpCommandFailureContextualizedType(apiSections.SESSION_SECTION))) {
          _context4.next = 87;
          break;
        }
        _context4.next = 82;
        return put(setSessionKo());
      case 82:
        if (!(pathname !== '/')) {
          _context4.next = 85;
          break;
        }
        _context4.next = 85;
        return put(logout());
      case 85:
        _context4.next = 102;
        break;
      case 87:
        if (!(s_commandName === 'hl_openSession')) {
          _context4.next = 100;
          break;
        }
        // check dmpconnectjs version
        s_serviceVersion = data.s_serviceVersion;
        _context4.next = 91;
        return select(getDmpConnectJSVersion);
      case 91:
        minimumVersion = _context4.sent;
        if (checkDMPConnectJSVersion(s_serviceVersion, minimumVersion)) {
          _context4.next = 100;
          break;
        }
        _context4.next = 95;
        return put(setConnectorVersionKo(s_serviceVersion));
      case 95:
        _context4.next = 97;
        return delay(5000);
      case 97:
        _context4.next = 99;
        return call(openSession, false);
      case 99:
        return _context4.abrupt("return");
      case 100:
        _context4.next = 102;
        return put(setSessionOk());
      case 102:
        _context4.next = 106;
        break;
      case 104:
        _context4.next = 106;
        return put(setSessionOk());
      case 106:
      case "end":
        return _context4.stop();
    }
  }, openSession);
});
var initStatesAndMonitoring = /*#__PURE__*/_regeneratorRuntime().mark(function initStatesAndMonitoring() {
  var pathname;
  return _regeneratorRuntime().wrap(function initStatesAndMonitoring$(_context5) {
    while (1) switch (_context5.prev = _context5.next) {
      case 0:
        _context5.next = 2;
        return select(getCurrentPathnameAccessor);
      case 2:
        pathname = _context5.sent;
        _context5.next = 5;
        return call(handleGetInteropCodes);
      case 5:
        _context5.next = 7;
        return call(handleDmpParameters);
      case 7:
        _context5.next = 9;
        return call(handleGetNosCodes);
      case 9:
        _context5.next = 11;
        return put(initApplicationSuccess());
      case 11:
        if (!(pathname !== '/')) {
          _context5.next = 14;
          break;
        }
        _context5.next = 14;
        return put(startCpxMonitoring());
      case 14:
      case "end":
        return _context5.stop();
    }
  }, initStatesAndMonitoring);
});
export var checkLicenseProcess = /*#__PURE__*/_regeneratorRuntime().mark(function checkLicenseProcess() {
  var cpxReader, result;
  return _regeneratorRuntime().wrap(function checkLicenseProcess$(_context6) {
    while (1) switch (_context6.prev = _context6.next) {
      case 0:
        _context6.next = 2;
        return put(setLicenseMonitoringLoading(true));
      case 2:
        _context6.next = 4;
        return select(getCpxReader);
      case 4:
        cpxReader = _context6.sent;
        _context6.next = 7;
        return put(readCpxProcess(getSavedPinCode(), cpxReader, false));
      case 7:
        _context6.next = 9;
        return take(dmpCommandSuccessContextualizedType(apiSections.CPX_CARD_SECTION));
      case 9:
        _context6.next = 11;
        return put(getCommandAction(commands.checkUserLicenseRight, apiSections.CHECK_LICENSE_USER_RIGHT));
      case 11:
        _context6.next = 13;
        return take([dmpCommandSuccessContextualizedType(apiSections.CHECK_LICENSE_USER_RIGHT), dmpCommandFailureContextualizedType(apiSections.CHECK_LICENSE_USER_RIGHT)]);
      case 13:
        result = _context6.sent;
        if (!(result && result.type === dmpCommandSuccessContextualizedType(apiSections.CHECK_LICENSE_USER_RIGHT))) {
          _context6.next = 17;
          break;
        }
        _context6.next = 17;
        return put(setLicenseAfterFormOK());
      case 17:
        _context6.next = 19;
        return put(setLicenseMonitoringLoading(false));
      case 19:
      case "end":
        return _context6.stop();
    }
  }, checkLicenseProcess);
});
export var handleDMPSequence = /*#__PURE__*/_regeneratorRuntime().mark(function handleDMPSequence() {
  var _dmpProcesses;
  var dmpProcesses, requestChannel, payload, apiType;
  return _regeneratorRuntime().wrap(function handleDMPSequence$(_context7) {
    while (1) switch (_context7.prev = _context7.next) {
      case 0:
        dmpProcesses = (_dmpProcesses = {}, _defineProperty(_dmpProcesses, dmpconnectInitActionConstants.DMPC_RESET_APPLICATION, unregisterDcParameters), _defineProperty(_dmpProcesses, dmpconnectInitActionConstants.DMPC_INIT_APPLICATION, registerDcParameters), _defineProperty(_dmpProcesses, dmpconnectInitActionConstants.DMPC_DCPARAMS_REGISTERED, checkConnector), _defineProperty(_dmpProcesses, dmpconnectInitActionConstants.DMPC_SET_CONNECTOR_CONFIG_OK, openSession), _defineProperty(_dmpProcesses, dmpconnectInitActionConstants.DMPC_SET_SESSION_OK, initStatesAndMonitoring), _defineProperty(_dmpProcesses, dmpconnectInitActionConstants.DMPC_LICENSE_CHECK, checkLicenseProcess), _dmpProcesses);
        _context7.next = 3;
        return actionChannel(Object.keys(dmpProcesses));
      case 3:
        requestChannel = _context7.sent;
      case 4:
        if (!true) {
          _context7.next = 16;
          break;
        }
        _context7.next = 7;
        return take(requestChannel);
      case 7:
        payload = _context7.sent;
        _context7.next = 10;
        return select(getApiType);
      case 10:
        apiType = _context7.sent;
        if (!(apiType === API_TYPES.WS)) {
          _context7.next = 14;
          break;
        }
        _context7.next = 14;
        return call(dmpProcesses[payload.type], payload);
      case 14:
        _context7.next = 4;
        break;
      case 16:
      case "end":
        return _context7.stop();
    }
  }, handleDMPSequence);
});
export var handleJSPostSequence = /*#__PURE__*/_regeneratorRuntime().mark(function handleJSPostSequence() {
  var _dmpProcesses2;
  var dmpProcesses, requestChannel, payload, apiType;
  return _regeneratorRuntime().wrap(function handleJSPostSequence$(_context8) {
    while (1) switch (_context8.prev = _context8.next) {
      case 0:
        dmpProcesses = (_dmpProcesses2 = {}, _defineProperty(_dmpProcesses2, dmpconnectInitActionConstants.DMPC_RESET_APPLICATION, unregisterDcParameters), _defineProperty(_dmpProcesses2, dmpconnectInitActionConstants.DMPC_INIT_APPLICATION, registerDcParameters), _defineProperty(_dmpProcesses2, dmpconnectInitActionConstants.DMPC_DCPARAMS_REGISTERED, openSession), _defineProperty(_dmpProcesses2, dmpconnectInitActionConstants.DMPC_SET_SESSION_OK, initStatesAndMonitoring), _defineProperty(_dmpProcesses2, dmpconnectInitActionConstants.DMPC_LICENSE_CHECK, checkLicenseProcess), _dmpProcesses2);
        _context8.next = 3;
        return actionChannel(Object.keys(dmpProcesses));
      case 3:
        requestChannel = _context8.sent;
      case 4:
        if (!true) {
          _context8.next = 16;
          break;
        }
        _context8.next = 7;
        return take(requestChannel);
      case 7:
        payload = _context8.sent;
        _context8.next = 10;
        return select(getApiType);
      case 10:
        apiType = _context8.sent;
        if (!(apiType === API_TYPES.JSPOST)) {
          _context8.next = 14;
          break;
        }
        _context8.next = 14;
        return call(dmpProcesses[payload.type], payload);
      case 14:
        _context8.next = 4;
        break;
      case 16:
      case "end":
        return _context8.stop();
    }
  }, handleJSPostSequence);
});
export var handleJSONSequence = /*#__PURE__*/_regeneratorRuntime().mark(function handleJSONSequence() {
  var _dmpProcesses3;
  var dmpProcesses, requestChannel, payload, apiType;
  return _regeneratorRuntime().wrap(function handleJSONSequence$(_context9) {
    while (1) switch (_context9.prev = _context9.next) {
      case 0:
        dmpProcesses = (_dmpProcesses3 = {}, _defineProperty(_dmpProcesses3, dmpconnectInitActionConstants.DMPC_INIT_APPLICATION, openSession), _defineProperty(_dmpProcesses3, dmpconnectInitActionConstants.DMPC_SET_SESSION_OK, initStatesAndMonitoring), _defineProperty(_dmpProcesses3, dmpconnectInitActionConstants.DMPC_LICENSE_CHECK, checkLicenseProcess), _dmpProcesses3);
        _context9.next = 3;
        return actionChannel(Object.keys(dmpProcesses));
      case 3:
        requestChannel = _context9.sent;
      case 4:
        if (!true) {
          _context9.next = 16;
          break;
        }
        _context9.next = 7;
        return take(requestChannel);
      case 7:
        payload = _context9.sent;
        _context9.next = 10;
        return select(getApiType);
      case 10:
        apiType = _context9.sent;
        if (!(apiType === API_TYPES.JSON)) {
          _context9.next = 14;
          break;
        }
        _context9.next = 14;
        return call(dmpProcesses[payload.type], payload);
      case 14:
        _context9.next = 4;
        break;
      case 16:
      case "end":
        return _context9.stop();
    }
  }, handleJSONSequence);
});